import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./App";
import "./index.css";
import "./styles/global.css";
import reportWebVitals from "./reportWebVitals";
import { AuthProvider } from "react-oidc-context";
import { ThemeProvider } from "@mui/material";
import theme from "./theme";
import { LanguageProvider } from "./contexts/LanguageContext";
import store from "./store";
import { initEruda } from "./utils/eruda";

initEruda();



const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <AuthProvider>
      <ThemeProvider theme={theme}>
        <LanguageProvider>
          <Router>
            <App />
          </Router>
        </LanguageProvider>
      </ThemeProvider>
    </AuthProvider>
  </Provider>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
